import { gql } from "@apollo/client";

export const GET_PRESCRIPTIONS = gql`
  query getOnlinePharmacyPrescriptions($petId: String) {
    getOnlinePharmacyPrescriptions(petId: $petId) {
      success
      prescriptions {
        id
        name
        itemId
        displayStatus
        petId
        petName
        prescribedAt
        expirationDate
        prescribedBy
      }
      hasMore
    }
  }
`;

export const GET_PRESCRIPTION_BY_ID = gql`
  query getOnlinePharmacyPrescriptionById($id: ID!) {
    getOnlinePharmacyPrescriptionById(id: $id) {
      prescription {
        id
        name
        itemId
        displayStatus
        petId
        petName
        prescribedAt
        expirationDate
        prescribedBy
        allowedUse
        quantity
        remainingFills
        instructions
      }
    }
  }
`;

export const GET_MEDICINE_URL_BY_ID = gql`
  query getOnlinePharmacyItems($itemId: ID!) {
    getOnlinePharmacyItems(itemId: $itemId) {
      url
    }
  }
`;
